<template>
  <div class="upload-container">
    <el-button
      :style="{ background: color, borderColor: color }"
      icon="el-icon-upload"
      type="primary"
      @click="dialogVisible = true"
      >上传图片
    </el-button>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
      <el-upload
        :multiple="true"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="handleRemove"
        :before-upload="beforeUpload"
        class="editor-slide-upload"
        action=""
        :http-request="handleFileChange"
        list-type="picture-card"
        :accept="accept"
        :upload-folder="uploadFolder"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { getUploadPresignedUrl } from '@/api/common'
export default {
  name: 'EditorSlideUpload',
  props: {
    color: {
      type: String,
      default: '#1890ff',
    },
    // 限制上传文件类型
    accept: {
      type: String,
      default: 'image/*,video/*',
    },
    // 上传文件夹
    uploadFolder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      listObj: {},
      fileList: [],
    }
  },
  methods: {
    checkAllSuccess() {
      return Object.keys(this.listObj).every(
        (item) => this.listObj[item].hasSuccess,
      )
    },
    handleSubmit() {
      const arr = Object.keys(this.listObj).map((v) => this.listObj[v])
      if (!this.checkAllSuccess()) {
        this.$message(
          '请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！',
        )
        return
      }
      console.log(arr)
      this.$emit('successCBK', arr)
      this.listObj = {}
      this.fileList = []
      this.dialogVisible = false
    },
    handleRemove(file) {
      const uid = file.uid
      const objKeyArr = Object.keys(this.listObj)
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]]
          return
        }
      }
    },
    beforeUpload(file) {
      console.log(file)
      const _URL = window.URL || window.webkitURL
      const img = new Image()
      img.src = _URL.createObjectURL(file)
      this.listObj[file.uid] = {
        hasSuccess: false,
        uid: file.uid,
        name: file.name,
        width: this.width,
        height: this.height,
      }
    },
    async handleFileChange(option) {
      const file = option.file
      console.log(file)

      if (!file) {
        this.$message('获取文件信息失败')
        return
      }

      try {
        const folder = this.uploadFolder
        const fileKey = folder + file.name

        // 1. 从后端获取预签名 URL
        const res = await getUploadPresignedUrl({
          file_name: fileKey,
          mime_type: file.type,
        })
        console.log(res)

        const { upload_url, key } = res.data

        // 2. 直接 PUT 到预签名 URL
        const uploadRes = await fetch(upload_url, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type,
            'Content-Disposition': 'inline',
          },
        })
        console.log(uploadRes)

        if (!uploadRes.ok) {
          throw new Error('上传失败')
        }

        // 3. 更新文件状态
        const cdnUrl = process.env.VUE_APP_AWS_S3_DOMAIN + key
        this.$set(this.listObj, file.uid, {
          ...this.listObj[file.uid],
          url: cdnUrl,
          hasSuccess: true,
        })

        option.onSuccess({ key: key }, file)
      } catch (error) {
        console.error('上传失败', error)
        this.$message('上传失败，请重试')
        option.onError(error)
      }
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  ::v-deep.el-upload--picture-card {
    width: 100%;
  }
}
</style>
